import * as ActionTypes from '../constants/actiontypes/referent';
import ReferentSelfcare from '../constants/models/referentSelfcare';
import ReferentAuth from '../constants/models/referentAuth';
import * as Loadings from '../constants/loadings/referent';
import * as R from 'ramda';
import * as Text from '../constants/toasterText/user';
import * as axios from 'axios';
import { toast } from 'react-toastify';

const toastConf = {position: toast.POSITION.TOP_RIGHT, autoClose:3000};

const ReferentReducer = (state = {
    isLoading: [],
    user: undefined
    
}, action) => {
    switch(action.type){
        
        case ActionTypes.FETCH_USERREPRESENTATIVE_REQUEST:
            state.signupStep4Success = false;
            if (!state.isLoading.includes(Loadings.FETCHING_USERREPRESENTATIVE)) {
                state.isLoading = state.isLoading.concat(Loadings.FETCHING_USERREPRESENTATIVE);
            }
            return { ...state };

        case ActionTypes.FETCH_USERREPRESENTATIVE_SUCCESS:
            state.isLoading = state.isLoading.filter(l => l !== Loadings.FETCHING_USERREPRESENTATIVE);
            state.user = new ReferentSelfcare(action.data);        
            return { ...state };


        case ActionTypes.UPDATE_USERREPRESENTATIVE_REQUEST:
            state.signupStep4Success = false;
            if (!state.isLoading.includes(Loadings.UPDATING_USERREPRESENTATIVE)) {
                state.isLoading = state.isLoading.concat(Loadings.UPDATING_USERREPRESENTATIVE);
            }
            return { ...state };

        case ActionTypes.UPDATE_USERREPRESENTATIVE_SUCCESS:
            state.isLoading = state.isLoading.filter(l => l !== Loadings.UPDATING_USERREPRESENTATIVE);
            state.user = new ReferentSelfcare(action.data);        
            return { ...state };


        case ActionTypes.AUTHENTICATE_REQUEST:
            state.signupStep4Success = false;
            if (!state.isLoading.includes(Loadings.AUTHENTICATING_USERREPRESENTATIVE)) {
                state.isLoading = state.isLoading.concat(Loadings.AUTHENTICATING_USERREPRESENTATIVE);
            }
            return { ...state };

        case ActionTypes.AUTHENTICATE_SUCCESS:
            state.isLoading = state.isLoading.filter(l => l !== Loadings.AUTHENTICATING_USERREPRESENTATIVE);
            let referentAuth = new ReferentAuth(action.data);
            localStorage.setItem("access_token", referentAuth.jwtToken);
            axios.defaults.headers.common['Authorization'] = "Bearer " + referentAuth.jwtToken;    
            return { ...state };

        case ActionTypes.AUTHENTICATE_FAILURE:
            state.isLoading = state.isLoading.filter(l => l !== Loadings.AUTHENTICATING_USERREPRESENTATIVE);
            return { ...state };

        case ActionTypes.LINK_REQUEST:
            if (!state.isLoading.includes(Loadings.LINKING_USERREPRESENTATIVE)) {
                state.isLoading = state.isLoading.concat(Loadings.LINKING_USERREPRESENTATIVE);
            }
            return { ...state };

        case ActionTypes.LINK_SUCCESS:
            state.isLoading = state.isLoading.filter(l => l !== Loadings.LINKING_USERREPRESENTATIVE);
            let referentAuthLink = new ReferentAuth(action.data);
            localStorage.removeItem("access_token");
            localStorage.setItem("access_token", referentAuthLink.jwtToken);
            axios.defaults.headers.common['Authorization'] = "Bearer " + referentAuthLink.jwtToken;    
            return { ...state };

        case ActionTypes.LINK_FAILURE:
            state.isLoading = state.isLoading.filter(l => l !== Loadings.LINKING_USERREPRESENTATIVE);
            return { ...state };

        default:
            return state;
    }
}
export default ReferentReducer;